import { API } from "aws-amplify";
import * as storage from "utils/local-storage";
import { IS_INTEGRATED_APP } from "./constants";
import { integratedGet, integratedPost, integratedPut, } from "./integrated-app-http-client";
import * as Sentry from "@sentry/react";

const API_NAME = "api";

export const isIntegratedApp = () => {
  return storage.local.getItem(IS_INTEGRATED_APP) === "true";
};

const handleHttpError = (error: any, method: string, path: string, options?: any) => {
  // Extract useful information from Amplify error
  const statusCode = error?.response?.status || error?.status || 'unknown';
  const errorMessage = error?.response?.data?.message || error?.message || 'Unknown error';
  
  // Mark this error as already reported to Sentry
  (error as any).sentryReported = true;
  (error as any).status = statusCode;
  
  Sentry.captureException(error, {
    tags: {
      feature: 'http_client',
      http_method: method,
      http_status: statusCode.toString()
    },
    extra: {
      path,
      method,
      statusCode,
      errorMessage,
      requestOptions: options,
      amplifyError: error
    }
  });
  
  throw error;
};

export const getRequest = (path: string, options?: any) => {
  if (isIntegratedApp() && !options?.skipIntegrationApi)
    return integratedGet(path, options);

  const myInit = {
    queryStringParameters: options?.queryParams,
    ...options,
  };
  
  return API.get(API_NAME, path, myInit).catch((error) => {
    handleHttpError(error, "GET", path, myInit);
  });
};

export const postRequest = (path: string, options?: any) => {
  if (isIntegratedApp()) return integratedPost(path, options);

  const myInit = {
    body: options?.body,
    queryStringParameters: options?.queryParams,
  };
  
  return API.post(API_NAME, path, myInit).catch((error) => {
    handleHttpError(error, "POST", path, myInit);
  });
};

export const putRequest = (path: string, options: { body?: any } = {}) => {
  if (isIntegratedApp()) return integratedPut(path, options);

  const myInit = {
    body: options.body,
  };
  
  return API.put(API_NAME, path, myInit).catch((error) => {
    handleHttpError(error, "PUT", path, myInit);
  });
};
